import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { appNamedRoutes } from 'routes';
import { getQueryFromState } from 'utils/query';
import { resetPassword, updateAccount } from 'actions/partner';
import Account from 'components/account/Account';

const mapStateToProps = (state) => {
  return {
    account: state.account,
    auth: state.auth,
    backLink: { pathname: appNamedRoutes.accounts, search: getQueryFromState(state.meta.accounts, 'accounts')},
    groups: state.filters.groups,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onGoBack: (backLink) => {
      dispatch(push(backLink));
    },
    onResetPassword: (id, email) => {
      dispatch(resetPassword(id, email));
    },
    onUpdate: (id, params) => {
      dispatch(updateAccount(id, params));
    },
  }
}

const AccountsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Account)

export default AccountsContainer;
